<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">
  
                <div class="searchForm">
                    <form>
                        <div class="row">
                            <div class="col-md-3">
                                <!-- <label>Search</label> -->
                                <input type="text" class="form-control" [(ngModel)]="search" [ngModelOptions]="{standalone: true}"
                                  placeholder="search by user id">
                            </div>
                            <div class="col-md-3">
                                <button type="submit" class="btn btn-gets" (click)="getData('', search)"> <i class="mdi mdi-search-web"></i> Search</button>
                            </div>
                        </div>
                    </form>
                </div>
  
                <div class="row">
                    <div class="col-12">
                        <h2>Admin</h2>
                        <div class="table-responsive">
                            <table class="table mb-0 table-bordered">
                                <thead>
                                    <tr>
                                      <th>Username</th>
                                      <th>balance</th>
                                      <th>P/L</th>
                                      <th>Exposure</th>
                                      <th>Client Share</th>
                                      <th>Up-line</th>
                                      <th>Options</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="data && data?.children?.data.length > 0">
  
                                  <tr *ngFor="let item of data?.children?.data; trackBy:trackByIndex;">
                                    <td>
                                      <div class="btn-group">
                                        <a href="javascript:void(0)" class="btn btn-option">{{item?.role_id == 1 ? 'A' : item?.role_id == 2 ? 'S' : item?.role_id == 3 ? 'M' : 'C'}}</a>
                                        &nbsp;&nbsp;
                                      </div>
                                      <a *ngIf="item?.role_id != 4" href="javascript:void(0)"
                                        routerLink="/users/child/{{item?.id}}">{{item?.username}}
                                        ({{item?.name}})</a>
                                      <span class="color-bk" *ngIf="item?.role_id == 4">{{item?.username}}
                                        ({{item?.name}})</span>
                                    </td>
                                    <td>{{item?.available_balance}}</td>
                                    <td>{{item?.pl}}</td>
                                    <td>{{item?.expose}}</td>
                                    <td>{{item?.partnership}}</td>
                                    <td>{{item?.parent?.username}} </td>
                                    <td>
                                      <div class="btn-group">
                                        <a href="javascript:void(0)" id="button-autoclose1" (click)="confirmBox(item)"
                                          class="btn btn-l dropdown-toggle" >
                                          <i class="mdi mdi-undo-variant" aria-hidden="true"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
  
                                </tbody>
  
                                <tbody *ngIf="data && data?.children?.data?.length == 0">
                                  <tr>
                                    <td colspan="10" class="noData"> {{env.noDataMsg}}</td>
                                  </tr>
                                </tbody>
  
                                <tbody *ngIf="!data">
                                  <tr>
                                    <td colspan="10">
                                      <app-loader class="no-overlay"></app-loader>
                                    </td>
                                  </tr>
                                </tbody>
                            </table>
  
                            <!-- pagination -->
                            <app-pagination [data]="data?.children" (changePage)="getData($event)"></app-pagination>
                            <!-- pagination -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  
  